export default (el) => {

  const $html = $('html'),
        $mobileMenu = $(el);

  // Open hamburger menu on click
  $('.mobile-menu-btn').on('click', () => {
    $html.attr('data-menu', 'open');
    $mobileMenu.attr('aria-hidden', 'false');
  });

  // Close hamburger menu on click
  $('.close-btn, .js-blocker').on('click', () => {
    $html.attr('data-menu', 'closed');
    $mobileMenu.attr('aria-hidden', 'true');
  });

  // Close hamburger menu on escape key
  $(document).on('keydown', ({ key }) => {
    if (key === 'Esc' || key === 'Escape') {
      $html.attr('data-menu', 'closed');
      $mobileMenu.attr('aria-hidden', 'true');
    }
  });


  $(el).find('.js-menu-item-trigger').on('click', ({ currentTarget }) => {

    const $trigger = $(currentTarget),
          target   = $trigger.attr('aria-controls'),
          $content = $(`#${target}`);

    $trigger.attr('aria-expanded', $trigger.attr('aria-expanded') === 'true' ? 'false' : 'true');
    $content.attr('aria-hidden', $content.attr('aria-hidden') === 'true' ? 'false' : 'true');

  });

};